<template>
  <v-navigation-drawer fixed app temporary :value="display" @input="input">
    <v-flex xs12 class="pa-3 text-xs-center sb-head" dark>
      <v-flex xs12 class="ma-2 mb-4 title">XHRIS</v-flex>
      <v-flex xs12>
        <v-avatar
          :size="80"
          class="grey lighten-4"
          >
          <profile-image class="img-cst" :src="$store.getters.getUserProfileImage(items.profileImage)" alt="avatar" />
        </v-avatar>
      </v-flex>
      <v-flex xs12 class="d-block userName">{{items.name}}</v-flex>
    </v-flex>
    <v-divider/>
    <v-list class="pt-0">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title class="center_middle">
            <v-icon small style="margin-right:10px">dashboard</v-icon>
            <router-link :to="{name: 'Home'}">
              Dashboard
            </router-link>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-for="item in items.authMenu" :key="item.title">
        <v-list-tile-content>
          <v-list-tile-title v-if="(item.name ==='Logout')" class="center_middle">
            <v-icon small style="margin-right:10px">{{item.icon}}</v-icon>
            <router-link :to="{name: item.name}">
              <b>{{item.title }}</b>
            </router-link>
          </v-list-tile-title>
          <v-list-tile-title class="center_middle" v-else-if="(item.name === 'Worklist' && wlCount > 0)">
            <v-icon small style="margin-right:10px">fiber_manual_record</v-icon>
            <router-link :to="{name: item.name}">
              {{item.title }}
            </router-link>
            <v-chip small color="red" text-color="white"><strong>{{wlCount}}</strong></v-chip>
          </v-list-tile-title>
          <v-list-tile-title v-else class="center_middle">
            <v-icon small style="margin-right:10px">fiber_manual_record</v-icon>
            <router-link :to="{name: item.name}">
              {{item.title }}
            </router-link>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-footer absolute class="j-center">
      &copy; 2018 ICT Waruna Nusa Sentana
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import ProfileImage from '@/components/ProfileImage'
import Vuex from 'vuex'

const worklistStore = Vuex.createNamespacedHelpers('Worklist')
const employeeStore = Vuex.createNamespacedHelpers('Employee')

export default {
  name: 'side-bar-menu',
  components: {
    ProfileImage
  },
  props: {
    items: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      wlCount: 0
    }
  },
  computed: {
    display () {
      return this.$store.state.drawer
    },
    ...employeeStore.mapState({
      employees: 'items'
    }),
    employee () {
      const results = this.employees.filter(x => x.nik === this.$store.state.login.username)
      return results.length > 0 ? results[0] : {}
    }
  },
  methods: {
    ...worklistStore.mapActions({
      worklistCount: 'worklistCount'
    }),
    ...employeeStore.mapActions({
      list: 'list'
    }),
    input (value) {
      if (value === false) {
        this.$store.dispatch('toggleDrawer')
      } else {
        this.list({vueinstance: this}).then(res => {
          this.worklistCount({vueinstance: this, empid: this.employee.empId})
            .then(res => {
              this.wlCount = res
            })
            .catch(err => {
              this.wlCount = 0
              this.$error(err)
            })
        }).catch(err => this.$error(err))
      }
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 599px) {
  .mx-auto{
    font-size: 12px;
  }
}
.img-cst{
  border: 2px solid #ffffff;
}
.title,.userName{
  color: #ffffff
}
.sb-head{
  background-color: #2196F3;
}
.userName{
  padding: 0 10px;
  margin: 5px;
  font-size: 15px;
  font-weight: 600;
}
.center_middle{
  display: flex;
  justify-content: left;
  align-items: center;
}
.j-center{
  justify-content: center;
  border-top: 1px solid #dedede;
}
</style>



// WEBPACK FOOTER //
// src/components/SideBarMenu.vue